<template>
  <div align="left" class="brief">
    <Header :hasBack="goback" :hasRight="false">
    </Header>
    <div style="padding: 0 60px; flex: 1; width: 800px; margin: auto">
      <h2 align="center" style="margin-top: 0">About kssd</h2>
      <p>Kssd: K-mer substring space sampling/shuffling Decomposition</p>
      <p>
        Kssd is a sequences sketching tool for resemblance- and
        containment-analysis and composition analysis. It sketches sequences by
        k-mer substring space sampling/shuffling, please see our Genome Biology
        paper
        <span style="text-decoration: underline; color: #551a8b"
          >(https://genomebiology.biomedcentral.com/articles/10.1186/s13059-021-02303-4)</span
        >
        for how it works. It handles DNA sequences of both fasta or fastq
        format, whether gzipped or not.
      </p>
    </div>

    <Footer style="width: 800px; margin: auto" />
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
export default {
  name: 'brief',
  components: { Footer, Header },
  data () {
    return {
      goback: true
    }
  },
  mounted () {
    if (this.$route.query.goback !== undefined) {
      this.goback = this.$route.query.goback === 1
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.brief {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.navbar {
  position: relative;
  min-height: 50px;
  line-height: 50px;
  border-radius: 0px;
  box-shadow: rgb(153 153 153) 0px 1px 5px;
  z-index: 1;
  border: 0px;
  margin-bottom: 21px;
}
.navbar-content {
  max-width: 1170px;
  margin: auto;
  width: 100%;
  height: 100%;
  min-height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/brief.vue